import Icon from "@/icons";

export default function Attachments({ attachments, setAttachments, textareaRef, setSend, replyTo }: any) {
    return (
        <div className={`flex items-center space-x-2 bg-brand-back px-2 ${replyTo ? 'border-t border-gray-500' : 'rounded-t-lg'} w-full`}>
            <div className="flex items-center space-x-1 bg-brand-back p-2 rounded-t-lg w-full overflow-auto">
                {attachments.map((attachment: any, index: number) => (
                    <div key={index} className="relative flex items-center space-x-2 bg-brand-back p-2 rounded-t-lg">
                        <div className="relative bg-brand-back rounded-full">
                            <img src={attachment.url} className="max-w-64 max-h-64 rounded-lg" />
                            <div className="absolute top-0 -right-1  rounded-full cursor-pointer p-1 bg-brand-green" onClick={() => {
                                setAttachments(attachments.filter((_:string, i:number) => i !== index))
                                if (attachments.length > 1 && !!(textareaRef.current.value.trim().length > 0 && textareaRef.current.value.trim().length <= 2000 && !textareaRef.current.value.trim().match(/^#+\s*$/))) {
                                    setSend(true);
                                }
                            }}>
                                <Icon name="delete" size="16" color="white" />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}